import { api } from "./AxiosInstance";

export const EmpOnboarding = async (payload) =>
  await api.post(`/api/employees/personal-details`, payload);

export const ContactDetailAPi = async (payload) =>
  await api.post(`/api/employees/contact-details`, payload);

export const AddressDetailAPi = async (payload) =>
  await api.post(`/api/employees/address-details`, payload);

export const EducationDetailAPi = async (payload) =>
  await api.post(`/api/employees/education-details`, { education: payload });

export const KnowMyTeamAPI = async (payload) =>
  await api.post(`/api/employees/know-my-team`, payload);

export const BankDetailAPI = async (payload) =>
  await api.post(`/api/employees/bank-details`, payload);

export const uploadDocumentsAPI = async (formData) => {
  return await api.post(`/api/employees/upload-documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const extractDocumentInfoAPI = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await api.post(`/ocr/detect/extract/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const SubmitNomineeApi = async (payload) => {
  const formattedPayload = payload.map((item) => ({
    ...item,
    share_percentage: parseInt(item.share_percentage),
  }));

  return await api.post(`/api/employees/nominee-details`, {
    nominees: formattedPayload,
  });
};

export const getEmployeeDetailApi = async (type) =>
  await api.get(`/api/employees/employee-details`);

export const getEmployeeDetailApi2 = async (id) =>
  await api.get(`/api/employees/admin-employee-details?_id=${id}`);
